import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "../Components/pages/home/Home";
import About from "../Components/pages/about";
import Shop from "../Components/pages/shop";
import ProductDetail from "../Components/pages/product-detail";
import Register from "../Components/pages/register";
import Login from "../Components/pages/login";
import CartPage from "../Components/pages/cart-page";
import CheckOut from "../Components/pages/check-out";
import Contact from "../Components/pages/contact";
import MyAccount from "../Components/pages/my-account";
import ShippingAddress from "../Components/pages/my-account/shippingAddress";
import Layout from "../Components/layout";
import OrderDetails from "../Components/pages/my-account/OrderDetails";
import Wishlist from "../Components/pages/wishlist";
import PaymentSuccess from "../Components/pages/payment-success";
import EditBillingAddress from "../Components/pages/my-account/editBillingAddress";
import EditShippingAddress from "../Components/pages/my-account/editShippingAddress";
import BillingAddress from "../Components/pages/my-account/billingAddress";
import ForgotPassword from "../Components/pages/forgot-password"
import ForgotOTP from "../Components/pages/forgot-otp"
import ResetPassword from "../Components/pages/reset-password"
import ResetPasswordExternal from "../Components/pages/reset-external"

import PrivacyPolicy from "../Components/pages/privacy-policy"
import TermsandCondition from "../Components/pages/terms-and-condition"

import ShippingPolicy from "../Components/pages/shipping-policy"
import RefundPolicy from "../Components/pages/refund-policy"

function Index() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
      <Route
        path="/about"
        element={
          <Layout>
            <About />
          </Layout>
        }
      />
      <Route
        path="/shop"
        element={
          <Layout>
            <Shop />
          </Layout>
        }
      />
      <Route
        path="/product-detail/:id"
        element={
          <Layout>
            <ProductDetail />
          </Layout>
        }
      />
      <Route
        path="/register"
        element={
          <Layout>
            <Register />
          </Layout>
        }
      />
      <Route
        path="/login"
        element={
          <Layout>
            <Login />
          </Layout>
        }
      />
      <Route
        path="/cart-page"
        element={
          <Layout>
            <CartPage />
          </Layout>
        }
      />
      <Route
        path="/cart-page"
        element={
          <Layout>
            <CartPage />
          </Layout>
        }
      />
      <Route
        path="/checkout/:cartId"
        element={
          <Layout>
            <CheckOut />
          </Layout>
        }
      />
      <Route
        path="/my-account"
        element={
          <Layout>
            <MyAccount />
          </Layout>
        }
      />
      <Route
        path="/add-billing-address/:id"
        element={
          <Layout>
            <BillingAddress />
          </Layout>
        }
      />
      <Route
        path="/add-shipping-address/:id"
        element={
          <Layout>
            <ShippingAddress />
          </Layout>
        }
      />
      <Route
        path="/contact"
        element={
          <Layout>
            <Contact />
          </Layout>
        }
      />

      <Route
        path="/orders/:id/:orderId"
        element={
          <Layout>
            <OrderDetails />
          </Layout>
        }
      />

      <Route
        path="/wishlist"
        element={
          <Layout>
            <Wishlist />
          </Layout>
        }
      />
      <Route
        path="/payment-success"
        element={
          <Layout>
            <PaymentSuccess />
          </Layout>
        }
      />

      <Route
        path="/edit-billing-address/:id"
        element={
          <Layout>
            <EditBillingAddress />
          </Layout>
        }
      />
      <Route
        path="/edit-shipping-address/:id"
        element={
          <Layout>
            <EditShippingAddress />
          </Layout>
        }
      />

      <Route
        path="/forgot-password"
        element={
          <Layout>
            <ForgotPassword />
          </Layout>
        }
      />

      <Route
        path="/forgot-otp"
        element={
          <Layout>
            <ForgotOTP />
          </Layout>
        }
      />
      <Route
        path="/reset-password"
        element={
          <Layout>
            <ResetPassword />
          </Layout>
        }
      />

      <Route
        path="/reset-password-external/:emailEncrypted"
        element={
          <Layout>
            <ResetPasswordExternal />
          </Layout>
        }
      />

      <Route
        path="/privacy-policy"
        element={
          <Layout>
            <PrivacyPolicy />
          </Layout>
        }
      />

      <Route
        path="/terms-and-conditions"
        element={
          <Layout>
            <TermsandCondition />
          </Layout>
        }
      />

      <Route
        path="/shipping-policy"
        element={
          <Layout>
            <ShippingPolicy />
          </Layout>
        }
      />


      <Route
        path="/refund-policy"
        element={
          <Layout>
            <RefundPolicy />
          </Layout>
        }
      />

    </Routes>
  );
}

export default Index;
